<template>
  <div class="tva-viz-timeline-component">
    <div v-if="$tvaMq !== 'mobile'">
      <div class="tab" v-for="(tab, tabIndex) in content.accordion" :key="'tab-'+tabIndex">
        <div class="tab-content" @click="toggleFeatures(tabIndex)">
          <div :class="['title', {'open' : isIncluded(featuresOpen, tabIndex)}]">
            <svgicon icon="close-stroke" width="25" height="25"></svgicon>
            <p>{{tab.title}}</p>
          </div>

          <img :src="`${baseUrl}images/${tab.close_image}.svg`">
          <transition name="fade">
            <div :class="['tab-content-content']" v-show-slide="isIncluded(featuresOpen, tabIndex)">
              <img :src="`${baseUrl}images/${tab.open_image}.svg`">
            </div>
          </transition>
        </div>
      </div>
      <img class="third-image" :src="`${baseUrl}images/${content.third_image}.svg`">
    </div>
    <!-- MOBILE MOBILE MOBILE -->
    <div v-if="$tvaMq === 'mobile'">
      <div
        class="tab-sections"
        v-for="(section, sectionIndex) in content.accordion"
        :key="'section'+sectionIndex"
      >
        <h5>{{section.title}}</h5>
        <div
          :class="['tab', {'open' : isIncluded(featuresOpen, sectionIndex+'-'+tabMobIndex)}, {'first' : section.title === 'Target'},{'second' : section.title === 'Ambition'}]"
          v-for="(tab, tabMobIndex) in section.mobileContent"
          :key="'tab-mobile'+tabMobIndex"
        >
          <div class="tab-content" @click="toggleFeatures(sectionIndex+'-'+tabMobIndex)">
            <h4>{{tab.year}}</h4>
            <transition name="fade">
              <div
                :class="['tab-content-content']"
                v-show-slide="isIncluded(featuresOpen, sectionIndex+'-'+tabMobIndex)"
              >
                <p
                  v-for="(element, listIndex) in tab.content"
                  :key="'list'+listIndex"
                  v-html="element"
                ></p>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="tab-sections">
        <h5>{{content.third_title}}</h5>
        <div class="tab third">
          <ul>
            <li
              v-for=" (element, index) in content.third_list"
              :key="'third'+index"
              v-html="element"
            ></li>
          </ul>
        </div>
      </div>
      <p v-html="content.dida"></p>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content"],
  data() {
    return {
      featuresOpen: [],
      baseUrl: process.env.BASE_URL
    };
  },
  methods: {
    toggleFeatures(value) {
      if (this.isIncluded(this.featuresOpen, value)) {
        let index = this.featuresOpen.indexOf(value);
        this.featuresOpen.splice(index, 1);
      } else {
        this.featuresOpen.push(value);
      }
    },
    isIncluded(array, value) {
      return array.indexOf(value) >= 0;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
.tva-viz-timeline-component {
  max-width: 790px;
  margin: 0 auto;
  .tab {
    .tab-content {
      position: relative;
      .title {
        display: flex;
        align-items: center;
        position: absolute;
        top: 20px;
        left: 0;
        cursor: pointer;
        &.open {
          .svg-icon {
            transform: rotate(45deg);
            fill: $eni-grey;
            stroke: white;
          }
        }
        &:hover {
          .svg-icon {
            fill: $eni-grey;
            stroke: white;
          }
        }
        p {
          text-transform: uppercase;
          font-weight: 800;
          font-size: 14px;
        }
        .svg-icon {
          stroke: black;
          fill: none;
          margin-right: 0.5em;
          transition: all 0.5s ease;
        }
      }
    }
  }
  .third-image {
    margin-top: 50px;
  }
}
@media (max-width: 1024px) {
  .tva-viz-timeline-component {
    padding: 0 60px;
    .tab {
      .tab-content {
        .title {
          top: 15px;
        }
      }
    }
  }
  img {
    width: 100%;
  }
}
@media (max-width: 720px) {
  .tva-viz-timeline-component {
    padding: 0 30px;
    margin: 50px 0;
    h4 {
      border-left: solid 2px $eni-yellow;
      padding-left: 10px;
      margin-bottom: 10px;
      font-weight: 800;
      font-size: 20px;
      margin: 5px 0;
    }
    h5 {
      margin: 0;
      text-transform: uppercase;
    }
    .tab-sections {
      margin-top: 20px;
    }
    .tab {
      margin: 10px 0;
      border-radius: 10px;
      -webkit-box-shadow: 2px 2px 10px 0px rgba(173, 173, 173, 0.4);
      -moz-box-shadow: 2px 2px 10px 0px rgba(173, 173, 173, 0.4);
      box-shadow: 2px 2px 10px 0px rgba(173, 173, 173, 0.4);
      &.open.first {
        background: rgba(#a5de8d, 0.2);
        border: solid 1px #58a03a;
      }

      &.open.second {
        background: rgba(#fbcf66, 0.3);
        border: solid 1px #d78211;
      }

      &.third {
        background: rgba(#b7b7b7, 0.3);
        border: solid 1px #b7b7b7;
      }
      ul {
        li {
          font-family: "Avenir Next";
          font-size: 14px;
          font-weight: 400;
          line-height: 1.88;
          color: $eni-grey;
        }
      }
      .tab-content {
        padding: 20px 20px !important;
        .tab-content-content {
          flex-direction: column;
          align-items: flex-start;

          p {
            margin-top: 10px;
            border-bottom: solid 1px $eni-grey;
            padding: 10px 0;
            &:last-of-type {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
}
</style>

